import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import { FieldComponent } from '../../../types/FieldComponent';
import { compareText } from '../comparators/compareText';
import { TextFilter } from '../filters/TextFilter';
import { debounce } from 'lodash';
import TextField from '@mui/material/TextField';

export const SPTextField: FieldComponent<string, string[]> = ({
  onChange,
  defaultValue,
  forcedValue,
  disabled,
  isMissing,
}) => {
  const [currentState, setCurrentState] = useState<any>({
    value: undefined,
    send: false,
  });

  const debouncedChange = useCallback(
    debounce((newValue) => {
      onChange(newValue);
    }, 500),
    []
  );

  useEffect(() => {
    if (defaultValue) {
      setCurrentState({
        value: defaultValue,
        send: false,
      });
    }
  }, [defaultValue]);

  useEffect(() => {
    if (currentState.send) {
      debouncedChange(currentState.value);
    }
  }, [currentState, debouncedChange]);
  const handleChange = (value: any) => {
    setCurrentState({
      value: value,
      send: true,
    });
  };

  const ref = useRef<HTMLInputElement>();
  return (
    <>
      <TextField
        inputRef={ref}
        variant="outlined"
        size={'small'}
        value={currentState.value}
        disabled={disabled}
        className={`w-full ${isMissing ? 'error' : ''}`}
        label={`${isMissing ? 'This field is missing' : ''}`}
        onChange={(event) => {
          handleChange(event.target.value);
        }}
      />
    </>
  );
};

SPTextField.includes = (query = [], value = '') => {
  if (query.length === 0 || value === null) return true;
  const valueLowercase = value.toLowerCase();
  return query.some((queryPart) =>
    valueLowercase.includes(queryPart.toLowerCase())
  );
};

SPTextField.comparator = compareText;

SPTextField.FilterRenderer = TextFilter;
